var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "home" }, [
    _c("ul", { staticClass: "flexContent flex" }, [
      _c("li", { staticClass: "leftData flex flex-column" }, [
        _c(
          "div",
          { staticClass: "takeNumber bk_b" },
          [
            _c(
              "dv-border-box-10",
              [_c("roomsTop", { attrs: { roleType: "1" } })],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "sosAlarm bk_b" },
          [
            _c("dv-border-box-10", [
              _c(
                "div",
                { staticClass: "demo listPd" },
                [_c("feifang", { attrs: { roleType: "1" } })],
                1
              ),
            ]),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "sosAlarm bk_b" },
          [
            _c("dv-border-box-10", [
              _c(
                "div",
                { staticClass: "demo listPd" },
                [_c("workSpeed", { attrs: { roleType: "1" } })],
                1
              ),
            ]),
          ],
          1
        ),
      ]),
      _c("li", { staticClass: "middlePage flex flex-column flex-1" }, [
        _c(
          "div",
          { staticClass: "middleContent middle_1" },
          [_c("middleInfo")],
          1
        ),
        _c(
          "div",
          { staticClass: "middleContent middle_2" },
          [
            _c("dv-border-box-13", [
              _c(
                "div",
                { staticClass: "demo listPd" },
                [_c("searchRoom", { attrs: { roleType: "1" } })],
                1
              ),
            ]),
          ],
          1
        ),
      ]),
      _c("li", { staticClass: "rightData flex flex-column" }, [
        _c(
          "div",
          { staticClass: "probability bk_b" },
          [
            _c("dv-border-box-10", [
              _c(
                "div",
                { staticClass: "demo listPd" },
                [_c("placeOrder", { attrs: { roleType: "1" } })],
                1
              ),
            ]),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "probability bk_b" },
          [
            _c("dv-border-box-10", [
              _c(
                "div",
                { staticClass: "demo listPd" },
                [_c("checkInTime", { attrs: { roleType: "1" } })],
                1
              ),
            ]),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "probability bk_b" },
          [
            _c("dv-border-box-10", [
              _c(
                "div",
                { staticClass: "demo listPd" },
                [_c("checkInType", { attrs: { roleType: "1" } })],
                1
              ),
            ]),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }